import isString from 'lodash-es/isString';
export const toCamelCase = (text: string) => {
  if (!isString(text) || text === '') return text;
  if (text.length === 1) text.charAt(0).toLowerCase();
  return text.charAt(0).toLowerCase() + text.substring(1);
};
